import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';
import { Practitioner } from 'src/models';
import { UseQueryOverrideOptions } from '../common';

export type GetPractitionerListResponse = {
  practitioners: Practitioner[];
};

export type GetPractitionerListParams = {
  is_shown?: boolean;
};

export const useGetPractitionerList = (
  params?: GetPractitionerListParams,
  options: UseQueryOverrideOptions = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['practitionerList', params],
    queryFn: () =>
      api
        .get<GetPractitionerListResponse>(`/practitioners`, {
          params,
        })
        .then(({ data }) => data),
    refetchOnWindowFocus: false,
  });
};
